import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;

  h1 {
    line-height: normal;
  }

  button {
    align-self: flex-end;
  }
`

export const SurgeryCenterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-height: 140px;

  & > div {
    margin-right: 16px;
    margin-bottom: 16px;
  }
`

export const NoAvailableSurgeryCenter = styled.label`
  margin-top: 8px;
  font-size: 1em;
  color: #a4a4a4;
  font-weight: 400;
`

export const Inputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  height: 100%;
  align-content: flex-start;
  & > div {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
  }
`

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  button {
    width: 45%;
  }
`

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 64px;
  font-weight: 600;
  height: 370px;
  width: 500px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray};

  img {
    width: 90px;
    height: 90px;
  }
`
